import Bugsnag from '@bugsnag/js';
import { isRejectedWithValue } from '@reduxjs/toolkit';
import { displayAlert } from '@gogovan/entier-web-core/components/alert';
import statusCodeMessage from '@/utilities/status-code-message';

const statusCodeMapping = (statusCode) => {
  if (statusCodeMessage[statusCode]) return `${statusCodeMessage[statusCode]} [Status Code: ${statusCode}]`;
  return 'Unexpected Error';
};

/**
 * show a toast when rtk query throws error
 */
const rtkQueryErrorLogger = () => (next) => (action) => {
  if (isRejectedWithValue(action) && action.type.includes('Api')) {
    let message;
    const statusCode =
      typeof action.payload?.status === 'number' ? action.payload?.status : action.payload?.originalStatus;
    if (action.payload?.data?.payload) message = action.payload?.data?.payload;
    else message = statusCodeMapping(statusCode);
    displayAlert({ message, type: 'error' });

    Bugsnag.leaveBreadcrumb(
      'Request failed.',
      {
        status: statusCode,
        payload: action.payload?.data?.payload || action.payload?.data,
      },
      'error'
    );

    const isClientError = typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500;
    if (!isClientError) {
      Bugsnag.notify(new Error(message), (event) => {
        event.unhandled = true;
        event.severity = 'error';
      });
    }
  }

  return next(action);
};

export default rtkQueryErrorLogger;
